import script from "./CadenceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./CadenceSettings.vue?vue&type=script&setup=true&lang=js"

import "./CadenceSettings.vue?vue&type=style&index=0&id=5a3a2c60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a3a2c60"]])

export default __exports__